import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    ReferenceField,
    useRedirect,
    DeleteButton,
} from 'react-admin';

import { DateField } from './DateField';

const VideoReportsList = (props) => {
    return (
        <List {...props}>
            <Datagrid>
                <TextField source="id" />
                <ReferenceField
                    label="Vídeo reportado"
                    source="publication_id"
                    reference="publications"
                    link="show"
                    allowEmpty={false}
                >
                    <TextField source="id" />
                </ReferenceField>
                <TextField label="Motivo do report" source="report_type" />
                <ReferenceField
                    label="Usuário reportado"
                    source="user_id"
                    reference="users"
                    link="show"
                >
                    <TextField source="full_name" />
                </ReferenceField>
                <TextField label="Data do report" source="created_at" />
            </Datagrid>
        </List>
    );
};

export default VideoReportsList;
